import { render, staticRenderFns } from "./AssignDataPermissions.vue?vue&type=template&id=68013116&scoped=true"
import script from "./AssignDataPermissions.vue?vue&type=script&lang=js"
export * from "./AssignDataPermissions.vue?vue&type=script&lang=js"
import style0 from "./AssignDataPermissions.vue?vue&type=style&index=0&id=68013116&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68013116",
  null
  
)

export default component.exports